// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class CardsWhitelistsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'filtersCardsWhitelists';
        this.searchFields = [ "bin", "account", "panHash", "sources"];
        const defaultHead =
            [
                {
                    id: 'bin',
                    label: 'bin',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'account',
                    label: 'account',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'panHash',
                    label: 'panHash',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'sources',
                    label: 'sources',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                }
            ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.Server =
            this.props.context.getState().server.filtersCardsWhitelists;
        this.MenuDisplayType = 'menu';
        this.state = {
            ...this.state,
            head: this.Head
        };
    }


}
